import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ESEARCH_TYPE, TagItem, controlItem, tag } from './search-list.model'
import { dictionary } from './search-list.config'

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss'],
})
export class SearchListComponent implements OnInit {
  @Input() controlsPanel: controlItem[]
  @Output() public childSend = new EventEmitter()
  @Input() keyword: string = ''
  @Input() placeholder: string = ''
  @Input() inputKey: string = 'keyword' // 输入框的返回的参数key
  @Input() showInput: boolean = false
  // techs = []
  // majors = []
  queryParams = {}

  datePicker: Date
  value: string = ''
  eSearchType: typeof ESEARCH_TYPE = ESEARCH_TYPE
  constructor() {}

  i18nDictionary = dictionary;
  ngOnInit(): void {
    this.value = this.keyword
    this.queryParams[this.inputKey] = this.keyword
  }

  checkChange(type, item, items, value, name, children?, thirdChildren?) {
    const check = items.find((i) => i.flag).value !== value
    console.log('🚀 ~ file: search-list.component.ts:31 ~ SearchListComponent ~ checkChange ~ check:', check)

    this.tagChange(check, type, item, value, name, children, thirdChildren)
    this.resetFlag(check, items, value)
    this.concatParams()
  }

  tagChange(check, type, item, value, name, children, thirdChildren) {
    switch (type) {
      case ESEARCH_TYPE.TAG:
        this.disposeTagQuery(check, item, value, name, children, thirdChildren)
        break
      case ESEARCH_TYPE.TAG_RANGE:
        this.disposeTagRangeQuery(check, item, value, name)
        break
    }
  }

  disposeTagQuery(check, item, value, name, children, thirdChildren) {
    console.log('🚀 ~ file: search-list.component.ts:50 ~ SearchListComponent ~ disposeTagQuery ~ check, item, value, name, children:', check, item, value, name, children)
    const key = `${name}`
    if (value === '全部' || !value || !check) {
      this.queryParams[key] = ''
      if(children){
        this.queryParams[children.name] = ''
      }
      if(thirdChildren){
        this.queryParams[thirdChildren.name] = ''
      }
      children && (children.list = [new TagItem()])
      thirdChildren && (thirdChildren.list = [new TagItem()])
      console.log('全部', this.controlsPanel)
      return
    }

    this.queryParams[key] = value
    if(children){
      this.queryParams[children.name] = ''
    }
    if(thirdChildren){
      this.queryParams[thirdChildren.name] = ''
    }
    if (children && children.data && children.data.length) {
      children.list = []
      const list = children.data
        .filter((i) => i.pid === item.id)
        .map((i) => {
          i.flag = false
          return i
        })
      list.unshift(new TagItem())
      children.list = list
    }
    if (thirdChildren && thirdChildren.data && thirdChildren.data.length) {
      thirdChildren.list = [new TagItem()]
    }
    console.log('all', this.controlsPanel)
  }

  disposeTagRangeQuery(check, item, value, name) {
    const startKey = `${name}Start`
    const endKey = `${name}End`
    console.log('disposeTagRangeQuery', check)
    if (value === '全部' || !value || !check) {
      this.queryParams[startKey] = ''
      this.queryParams[endKey] = ''
      return
    }

    const [start, end] = item.value.split(',')
    this.queryParams[startKey] = start
    this.queryParams[endKey] = end
  }

  resetFlag(check, items, value) {
    console.log('🚀 ~ file: search-list.component.ts:98 ~ SearchListComponent ~ resetFlag ~ check, items, value:', check, items, value)
    const val = check ? value : '全部'
    items.forEach((i) => {
      i.flag = i.value === val
    })
    console.log('allll', this.controlsPanel)
  }

  searchChange(e) {
    this.value = e
  }

  onEnter() {
    this.queryParams[this.inputKey] = this.value
    this.concatParams()
  }
  onReset() {
    this.queryParams = {}
    this.controlsPanel.forEach((item) => {
      item.list.forEach((i) => {
        if (item.children) {
          item.children.list.forEach((c) => {
            c.flag = c.value == '全部' ? true : false
          })
        }
        i.flag = i.value == '全部' ? true : false
      })
      this.queryParams[item.name] = ''
    })
    this.value = ''
    this.queryParams[this.inputKey] = ''
    console.log('🚀 ~ file: search-list.component.ts:103 ~ SearchListComponent ~ onReset ~ this.controlsPanel:', this.controlsPanel)
    this.concatParams()
  }

  concatParams() {
    this.childSend.emit(this.queryParams)
  }

  viewMore(item) {
    const { collapse, minLength, data } = item
    item.list = collapse ? data.slice(0, minLength) : data.slice(0)
    item.collapse = !item.collapse
  }
}
